import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { IBillingProvincePropsComponent, IFormValues } from "../../../../types";
import {InvoiceType, ItCodeCountry, ReactQueryKey} from "../../../../../../types";
import { getProvinces } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";

const BillingProvinceField = (props: IBillingProvincePropsComponent) => {

    const { t } = useTranslation('booking');

    const invoiceBillingCountry = useWatch<IFormValues, 'invoice.billingCountry'>({
        name: 'invoice.billingCountry'
    })
    const invoiceType = useWatch<IFormValues, "invoice.type">({
        name: 'invoice.type'
    });

    const provincesQuery = useQuery({
        queryKey: [ReactQueryKey.Provinces, {
            country: invoiceBillingCountry,
            refetchOnMount: false
        }],
        queryFn: () => {
            if (!invoiceBillingCountry || invoiceBillingCountry === ItCodeCountry) {
                return null;
            }
            return getProvinces({
                country: invoiceBillingCountry
            })
        },
        enabled: invoiceBillingCountry !== ItCodeCountry,
        refetchOnMount: false
    });

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.billingProvince"
            label={t('label.billingProvince') + (invoiceType !== InvoiceType.PERSON ? '*' : '')}
            options={provincesQuery.data ?? []}
            disabled={props.billingProvinceDisabled}
        />
    )
}

export default BillingProvinceField;
